import i18n from '../language/index'
import link from './linkData'

/**
 * 去抖函数
 */
import Cookies from 'js-cookie'

export function mydebounce(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = parseInt(wait) || 0;

  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      timeWaiting = wait - timeSinceLastCall;

    return maxing ?
      nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) :
      timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Date.now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Date.now());
  }

  function debounced() {
    var time = Date.now(),
      isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

//创建一条历史记录
export function create_historical_data(val, name) {
  const data = {
    body: val.myRender.body,
    header: val.myRender.header,
    footer: val.myRender.footer,
    common: val.myRender.common,
    full_screen_banner: val.myRender.full_screen_banner,
    private: val.myRender.private,
  };
  const admin_theme_id = Cookies.get('admin_theme_id_wm') + '_' + Cookies.get('admin_token_wm');

  const record = {
    id: Date.now(),
    type: admin_theme_id,
    page: val.app.now_page,
    time: Date.now(),
    name,
    data: JSON.stringify(data)

  }
  return record;
}

//插入数据过滤
export function websql_data_filter(data) {
  const sql_val = [];
  for (var key in data) {
    sql_val.push(data[key]);
  }
  return sql_val;
}


export function gen_id(length = 8) {
  return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
}

//轮播多图，列表多图，图册的自定义图片格式
export function create_one_img(img_path = '', img_name = "") {
  return {
    img_type: 'custom',
    album_id: gen_id(),
    img_name,
    img_path,
    summary: '',
    intro: JSON.parse(JSON.stringify(link)),
    is_jump: 0,
    jump_url: ""
  }
}

//轮播多图，列表多图，图册的自定义创建初始数据
export function imgs_init() {
  const imgs = [];
  for (let i = 0; i < 4; i++) {
    const one = create_one_img('https://staticjs.71360.com/3/static/txys-001/image/' + i + '.jpg');
    imgs.push(one);
  }
  return imgs;
}

// 图标组合自定义创建初始数据
export function icons_init(option = {}) {
  const imgs = [];
  const length = option.length || 4
  for (let i = 0; i < length; i++) {
    option.img_path = 'https://staticjs.71360.com/static/txys-001/image/icon_combination_' + i + '.png'
    const one = create_one_icon(option);
    imgs.push(one);
  }
  return imgs;
}

// 图文轮播创建初始数据
export function pic_swiper_init(option = {}) {
  const imgs = [];
  const length = option.length || 4
  for (let i = 0; i < length; i++) {
    option.img_path = 'https://staticjs.71360.com/static/txys-001/image/pic-text-swiper/default-' + i + '.png'
    const one = create_one_icon(option);
    imgs.push(one);
  }
  return imgs;
}

// 图表组合的自定义图片格式
export function create_one_icon({
                                  img_path = '', img_name = "", title = '', summary = ''
                                }) {
  return {
    img_type: 'custom',
    album_id: gen_id(),
    img_name,
    img_path,
    title,
    summary,
    intro: JSON.parse(JSON.stringify(link)),
    is_jump: 0,
    jump_url: ""
  }
}

export function find_page(page_name, arr, key = 'name') {
  let s_page = {};
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key] == page_name) {
      s_page = arr[i];
    }
  }
  return s_page;
}

//新增发展历程
export function create_one_history() {
  return {
    id: gen_id(),
    link: JSON.parse(JSON.stringify(link)),
    title: '',
    summary: i18n.t('widgets_basic_development_history_style_500')
  }
}

export function historys_init(option = {}) {
  const historys = [];
  const length = option.length || 4
  for (let i = 0; i < length; i++) {
    const one = create_one_history(option);
    historys.push(one);
  }
  return historys;
}
// 折叠文本 这边 要写一个数据
export function flod_text_one_list() {
  return {
    id: gen_id(),
    link: JSON.parse(JSON.stringify(link)),
    title: i18n.t('widgets_basic_flod_text_edit_543'),
    content: i18n.t('widgets_basic_floating_frame_style_542'),
    icon_before: 'https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (25).png',
    icon_hover: 'https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (24).png'
  }
}
export function language_content_init() {
  const content_set = {};
  const langsObj = this.$store.state.options.languageContentData
  for(let langKey in langsObj) {
    const item = langsObj[langKey]
      content_set[langKey] = {
          value: langKey,
          isShow: 'false',
          name: item[0],
          label: item[1]
      }
    }
  return content_set;
}
/**
 * 转换字体颜色
 * 
 * @param {array} rgbArr rgb数组
 */
function resBgColor(rgbArr) {
  // 当color值大于128时,color值偏向255,即#ffffff,此时字体颜色应为#000000
  // 当color值小于128时,color值偏向0,即#000000,此时字体颜色应为#ffffff
  const r = rgbArr[0]
  const g = rgbArr[1]
  const b = rgbArr[2]
  var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
   return (yiq >= 128) ? 'rgba(0, 0, 0,1)' : 'rgba(255, 255, 255,1)';
}
function findTextColor (colorValue) {
      // #123456或者rgb(12,34,56)转为rgb数组[12,34,56]
      const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      var that = colorValue;
      if (/^(rgba|RGB)/.test(that)) {
          // 处理rgb转为数组
          var aColor = that.replace(/(?:\(|\)|rgba|RGB)*/g, "").split(",");
          return resBgColor(aColor);
      } else if (reg.test(that)) {
          // 处理十六进制色值
          var sColor = colorValue.toLowerCase();
          if (sColor && reg.test(sColor)) {
              if (sColor.length === 4) {
              var sColorNew = "#";
              for (var i = 1; i < 4; i += 1) {
                  sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
              }
              sColor = sColorNew;
          }
          //处理六位的颜色值
          var sColorChange = [];
          for (var i = 1; i < 7; i += 2) {
              sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
          }
          return resBgColor(sColorChange);
          } else {
              return false;
          }
      } else {
          return false;
      }
}

export function detail_button_style(type,theme_color,fontSize) {
  const detail_button_style = {
    type_0: {
      fontColor: findTextColor(theme_color),
      fontSeColor: findTextColor(theme_color),
      backgroundColor: theme_color,
      backgroundSeColor: theme_color,
      borderWidth: 0,
      borderStyle: 'solid',
      borderColor: "rgba(255, 255, 255,1)",
      borderSeColor: "rgba(0, 0, 0,1)",
      borderRadius: 4
    },
    type_1: {
      fontColor: findTextColor(theme_color),
      fontSeColor: findTextColor(theme_color) !== 'rgba(0, 0, 0,1)' ? theme_color : findTextColor(theme_color),
      backgroundColor: theme_color,
      backgroundSeColor: 'rgba(255,255,255,1)',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: theme_color,
      borderSeColor: theme_color,
      borderRadius: fontSize + 4
    },
    type_2: {
      fontColor: findTextColor(theme_color),
      fontSeColor: findTextColor(theme_color),
      backgroundColor: theme_color,
      backgroundSeColor: theme_color,
      borderWidth: 0,
      borderStyle: 'solid',
      borderColor: theme_color,
      borderSeColor: "rgba(0, 0, 0,1)",
      borderRadius: 4
    },
    type_3: {
      fontColor: 'rgba(51,51,51,1)',
      fontSeColor: findTextColor(theme_color) !== 'rgba(0, 0, 0,1)' ? theme_color : findTextColor(theme_color),
      backgroundColor: 'rgba(255,255,255,1)',
      backgroundSeColor: 'rgba(255,255,255,1)',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: "rgba(204, 204, 204,1)",
      borderSeColor: theme_color,
      borderRadius: fontSize + 4
    },
    type_4: {
      fontColor: findTextColor(theme_color) !== 'rgba(0, 0, 0,1)' ? theme_color : findTextColor(theme_color),
      fontSeColor: findTextColor(theme_color),
      backgroundColor: 'rgba(255,255,255,1)',
      backgroundSeColor: theme_color,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: theme_color,
      borderSeColor: theme_color,
      borderRadius: 0
    },
    type_5: {
      fontColor: findTextColor(theme_color) !== 'rgba(0, 0, 0,1)' ? theme_color : findTextColor(theme_color),
      fontSeColor: findTextColor(theme_color),
      backgroundColor: 'rgba(255,255,255,1)',
      backgroundSeColor: theme_color,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: theme_color,
      borderSeColor: theme_color,
      borderRadius: 0
    }
  }
  return detail_button_style[type]
}
export function lockScroll(isShow) {
  if(isShow) {
    $('html').addClass("el-popup-parent-imgPop--hidden")
  } else {
    console.log(222,$('.el-popup-parent-imgPop--dialog').length)
    if($('.el-popup-parent-imgPop--dialog').length == 0) {
      $('html').removeClass("el-popup-parent-imgPop--hidden")
    }
  }
}
export function throttle(fn, time = 100) {
  let timer = null
  let startTime = new Date()
  return (...args) => {
    let curTime = new Date()
    clearTimeout(timer)
    if (curTime - startTime >= time) {
      fn(args)
      startTime = curTime
    } else {
      timer = setTimeout(() => {
        fn(args)
      }, time)
    }
  }
}

export function getStaticStr(name) {
  let str = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-\s]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
  return str;
}



// WEBPACK FOOTER //
// ./src/base/base.js